export interface LoadingState {
    tasks: Record<string, string>;
}

export enum LoadingActionNames {
    SET_LOADING = 'SET_LOADING',
    SET_DONE = 'SET_DONE',
}
